import {api} from "@/frontend/lib/api";
import {VerificationStatus} from "@/frontend/lib/enums";
import TuVerificationStorage from "@/frontend/lib/tuCheck/storage";
import VerificationStorage from "@/frontend/lib/oneId/storage";
import {WidgetShop, WidgetVerification} from "@/types/frontend";

export class AgeVerification {
    private readonly shop: WidgetShop;
    private readonly token: string = "";
    private readonly custom_token: string = "";
    private readonly age: number = 0;
    private readonly validAges: number[] = [18];
    private status: VerificationStatus = VerificationStatus.PENDING;
    private isRequired = false;

    constructor(shop: WidgetShop, token: string,customToken: string, age: number = 0) {
        this.shop = shop;
        this.token = token;
        this.custom_token = customToken;
        this.age = age;
    }

    public async initialise(): Promise<void> {
        // whitelist age boundaries
        if (!this.hasValidAge()) {
            console.log(`ONEID_OVER_${this.age} is not permitted/whitelisted`);
            return;
        }

        if (!this.shop!.oneid_client_id) {
            console.log("Oneid disabled or inactive or limit exceeded! Aborting...");
            return;
        }

        if (this.age === 0) {
            return;
        }

        const storage = TuVerificationStorage.get();
        console.log("22222",storage);
        if (storage) {
            await this.processStoredData(storage);
        } else {
            this.setRequired();
        }
    }

    public required(): boolean {
        return this.isRequired;
    }

    public passed(): boolean {
        return this.status === VerificationStatus.PASSED;
    }

    public failed(): boolean {
        return this.status === VerificationStatus.FAILED;
    }

    private hasValidAge() {
        return this.age > 0 && this.validAges.includes(this.age);
    }

    private setRequired(required: boolean = true): void {
        this.isRequired = required;
    }

    private processVerification(verification: WidgetVerification | null): void {
        if (!verification) {
            this.setRequired();
            return;
        }

        TuVerificationStorage.set(verification);

        this.status = verification.verification_result == "passed" ? VerificationStatus.PASSED : VerificationStatus.FAILED;
    }

    private async processStoredData(storage: WidgetVerification): Promise<void> {

        if (storage.cart_token !== this.token) {
            TuVerificationStorage.clear();
            VerificationStorage.clear(); // Important: remove OneID storage
            this.setRequired();
            return;
        }

        // if (this.shop.enabled_age_check_persistence && !await TuVerificationStorage.hasExpired()) {
        //     this.status = storage.verification_result == "passed" ? VerificationStatus.PASSED : VerificationStatus.FAILED;
        //     return;
        // }
        console.log("2222 " + this.custom_token)
        const verification = await api.getTuCheckVerification({
            id: storage.id,
            existing_cart_token: storage.cart_token,
            cart_token: this.token,
            custom_token: this.custom_token,
            age_over: this.age,
        });
        console.log("2222 before ", verification)
        this.processVerification(verification);
    }
}
